<template>
    <project-step-container
        prev-to="be_deep_customer_empathy_6"
        :on-discard-project="redirection"
        :on-keep-version-project="redirection"
        @next-click="updateProject">
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"
                       :text="getMessage(7, 'empathy-map-guide')" ></LinkStyleGuide>
        <b-row class="first-form">
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
              {{getMessage(7, 'empathy-map-sub')}}           
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
import {Steps} from "@/modules/BeEntrepreneurship/Utils";
export default {
    name: "DeepCustomerEmpathy7",
    components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
    data() {
        return {
            step: Steps.FORM_WRITE_CUSTOMER_PROBLEM,
            styleGuide: StyleGuides.getStyleGuide(StyleGuides.CUSTOMER_INTERVIEW_GUIDE)
        }
    },
    methods: {
        openGuide() {
            this.$bvModal.show('project-style-guide')
        },
        updateProject() {
            const stepNumber = Steps.getStepFromForm(this.step)
            const index = this.$route.params.index

            Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                if (response.project?.hasDifferenceVersion) {
                    ConflictSyn.show(response.index, response.project)
                } else {
                    this.redirection()
                }
            }).catch(err => {
                this.redirection()
            })
        },
        redirection(){
            const index = this.$route.params.index
            this.$router.push({name: 'be_deep_customer_empathy_8', params: {index}})
        }
    }
}
</script>

